import React from "react";
import { default as MUIFormLabel } from "@mui/material/FormLabel";
import styled from "styled-components";

const StyledMUIFormLabel = styled(MUIFormLabel)``;

export const FormLabel = (props) => {
  return <StyledMUIFormLabel {...props} />;
};
